module.exports = __webpack_public_path__ + "img/503.bc1f66d1.png";